// Unity can preserve specular reflections even when its surface alpha is zero.
// Ordinary glTF alpha blending hides those reflections along with the surface.
export function getModelVistaGlassSettings(record) {
    const hdrp = record?.ShaderName === "HDRP/Lit";
    const urp = ["Universal Render Pipeline/Lit", "Universal Render Pipeline/Complex Lit",
        "Universal Render Pipeline/Simple Lit"].includes(record?.ShaderName);
    if (!hdrp && !urp) return null;
    const properties = new Map((record.Properties ?? []).map((property) => [
        String(property.Name).replace(/^_/, "").toLowerCase(), property
    ]));
    const scalar = (name, fallback) => Number(properties.get(name)?.FloatValue ?? fallback);
    if (scalar(hdrp ? "surfacetype" : "surface", 0) !== 1
        || scalar(hdrp ? "enableblendmodepreservespecularlighting" : "blendmodepreservespecular", 0) !== 1
        || scalar(hdrp ? "blendmode" : "blend", 0) !== 0
        || scalar(hdrp ? "alphacutoffenable" : "alphaclip", 0) !== 0
        || properties.has("transmissionfactor") || properties.has("transmission")) {
        return null;
    }
    const alpha = Number(properties.get("basecolor")?.VectorValue?.W ?? 1);
    if (!Number.isFinite(alpha) || alpha >= 1) return null;
    const ior = scalar("ior", 1.5);
    return {
        transmission: 1 - Math.max(0, alpha),
        ior: Number.isFinite(ior) ? Math.min(2.333, Math.max(1, ior)) : 1.5,
        // Transmission carries transparency; alpha must retain the glass surface.
        opacity: 1,
        transparent: false,
        metalness: 0,
        alphaTest: 0,
        depthWrite: true
    };
}
